import { Breakpoint } from '@philips-emr/tws-constants';
import { Value } from '@philips-emr/tws-core';
import { Validation } from '@philips-emr/tws-core/lib/services/model-service';
import { getBreakpoint } from '@philips-emr/tws-utils';

const NOT_RENDERED_COMPONENT_APIS = 'You should not access not rendered component apis.';
const CONFIRMATION_FIELD_VALID_EMAIL = 'confirmationField';
const CONFIRMATION_FIELD_VALID_PW = 'confirmationField';

const CONFIRMATION_FIELD_VALID = 'confirmationField';
const PW_VALIDATOR = 'passwordValidator';
const PW_NEW_DIFFERENT_CURRENT = 'passwordNewDifferentCurrent';

const PW = /^(?=.*?[A-Z])(?=(.*[a-z]))(?=(.*[\d]))(?=(.*[\W_])).{8,}$/;

function confirmationFieldValidatorEmail(value: Value, confirmationValue: Value): Validation[] {
  const valid = Boolean(value) && Boolean(confirmationValue) && confirmationValue === value;
  if (!value) {
    return [];
  }

  return [{
    message: !valid ? 'pa.invalid-confirm-email' : '',
    name: CONFIRMATION_FIELD_VALID_EMAIL,
    valid,
  }];
}

function confirmationFieldValidatorPassword(value: Value, confirmationValue: Value): Validation[] {
  const valid = Boolean(value) && Boolean(confirmationValue) && confirmationValue === value;
  if (!value) {
    return [];
  }

  return [{
    message: !valid ? 'pa.invalid-confirm-password' : '',
    name: CONFIRMATION_FIELD_VALID_PW,
    valid,
  }];
}

function passwordValidator(value: Value): Validation[] {
  const pass = value as string || '';
  const valid = Boolean(pass.match(PW)) && pass.length >= 8 && pass.length <= 16;

  return [{
    message: !valid ? 'pa.invalid-password' : '',
    name: PW_VALIDATOR,
    valid,
  }];
}

function confirmationFieldValidator(value: Value, confirmationValue: Value): Validation[] {
  const valid = Boolean(value) && Boolean(confirmationValue) && confirmationValue === value;

  return [{
    message: !valid ? 'pa.value-different-from-previous-field' : '',
    name: CONFIRMATION_FIELD_VALID,
    valid,
  }];
}

function passwordNewDifferentCurrent(value: Value, comparisonField: Value): Validation[] {
  const valid = value !== comparisonField;

  return [{
    message: !valid ? 'pa.password-new-equal-current' : '',
    name: PW_NEW_DIFFERENT_CURRENT,
    valid,
  }];
}

function shouldRenderMobile(): boolean {
  const breakpoint = getBreakpoint();
  return breakpoint === Breakpoint.SM || breakpoint === Breakpoint.XSM;
}

function getFilterDates(startDateKey = 'dtOpenning', endDateKey = 'dtClose', lessMonth = 1): Record<string, string> {
  const now = new Date();
  const lastMonth = new Date();
  lastMonth.setMonth(now.getMonth() - lessMonth);

  return {
    [startDateKey]: lastMonth.toISOString().slice(0, 10),
    [endDateKey]: now.toISOString().slice(0, 10),
  };
}

function catchRenderException(arg: () => void, defaultValue?: any): any {
  try {
    return arg();
  } catch (e) {
    const { message } = e as Error;
    const ignoreErr = [NOT_RENDERED_COMPONENT_APIS];
    if (!ignoreErr.includes(message)) {
      console.error(e);
    }
    return defaultValue;
  }
}

export {
  CONFIRMATION_FIELD_VALID_EMAIL,
  CONFIRMATION_FIELD_VALID_PW,
  PW_VALIDATOR,
  CONFIRMATION_FIELD_VALID,
  PW_NEW_DIFFERENT_CURRENT,
};

export {
  catchRenderException,
  confirmationFieldValidatorEmail,
  confirmationFieldValidatorPassword,
  shouldRenderMobile,
  getFilterDates,
  passwordValidator,
  confirmationFieldValidator,
  passwordNewDifferentCurrent,
};
